// extracted by mini-css-extract-plugin
export default {"root":"LayoutMobile_root__tjzFs","layout-container":"LayoutMobile_layout-container__Cfahk","containerLayoutMobile":"LayoutMobile_containerLayoutMobile__1dePS","video":"LayoutMobile_video__aPbaY","content":"LayoutMobile_content__TgNKk","title":"LayoutMobile_title__kVvIz","desc":"LayoutMobile_desc__4fuWw","laptop":"LayoutMobile_laptop__oNk8G"};
    if(module.hot) {
      // 1763464084271
      var cssReload = require("/usr/src/app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  